export default {
  updatePreviewBox2dShapeState(state, { val }) {
    state.previewBox2dShapeState = val
  },
  updatePreviewBox2dShapeAllState(state, { val }) {
    state.previewBox2dShapeAllState = val
  },
}
